import { ParseHelper } from './../../../modules/shared/parse.helper';
import { VisibilityAddedJobTypeUsers, VisibilityJobTypeUsers } from './models/visibility-job-type-users.model';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfirmationService, MessageService, TreeNode } from 'primeng/api';
import { Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { AppMainService } from 'src/app/app-main.service';
import { AppMainComponent } from 'src/app/app.main.component';
import { ConfigurationService } from '../../configurationService';
import { Answer } from '../../crm/constants/constants';
import { UserGroupsAdd } from './models/user-group.model';
import { VisibilityGroup } from './models/visibility-group.model';
import { VisibilityGroupService } from './services/visibility-group.service';
import { SharedChannelService } from 'src/app/modules/shared/services/channel.service';
import { ChannelN } from 'src/app/modules/shared/models/channel.model';
import { AccountModuleId, LeadModuleId } from 'src/app/modules/shared/constants/modules.constant';
import { SharedColumnSettingsService } from 'src/app/modules/shared/services/column-settings.service';
import { ColumnSettingsN } from 'src/app/modules/shared/models/column-settings.model';
import { AddModuleRecord } from './models/module-record.model';
import { getSectionWiseFlatCols } from 'src/app/modules/shared/helpers/section-wise-cols.helper';
import { Table } from 'primeng/table';
import { JobTypeService } from '../user/services/job-type.services';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-visibility-group',
  templateUrl: './visibility-group.component.html',
  styleUrls: ['./visibility-group.component.scss']
})
export class VisibilityGroupComponent implements OnInit, OnDestroy {

  configMenuProfileItems;
  tempGroup = {
    "id":0,
    "name":"",
    "description":"",
    "children":[
      {id:1,name:"User Groups",children:[]},
      {id:3,name:"Accounts",children:[]},
    ],
    "createdBy":this.app.currentUser.name,
    "updatedDate":new Date(),
    "isActive":true,
    "isDefault":false,
  }
  answertypeConstants = Answer;
  displayAddEditVisibilityModal=false;
  roles: TreeNode[];
  selectedRoles: TreeNode[];

  temp;
  first = 0;
  rows = 10;
  displayUserGroupTB = false;
  displaySelectedUserGroupTB = false;
  allUserGroup : any[]=[];
  allUserGroupForView : any[]=[];
  selectedUserGroups: any[]=[];
  allSelectedUserGroup: any[]=[];
  loading = true;

  //Job Type Users
  jobTypeList: VisibilityJobTypeUsers[] = [];
  jobTypeListByVisibility: VisibilityJobTypeUsers[] = [];
  selectedJobType: VisibilityJobTypeUsers;
  displaySelectedJobTypeUsersTB = false;
  addJobTypeUserEnable: boolean = false;

  assignedJobTypeUsers: VisibilityAddedJobTypeUsers[] = [];

  displaySelectJobTypeUsersTB = false;
  allJobTypeUsers: any[] = [];
  selectedJobTypeUsers: any[] = [];
  selectedJobTypeUsersToggle: boolean = false;
  defaultProfileImage = `${environment.assestsBasePath}layout/images/avatar5.png`;

  /* Subject to unsubscribe */
  private ngUnsubscribe = new Subject<void>();

  addEditVisibilityHeader: string;
  addEditVisibilityForm: FormGroup;
  visibilityGroup: VisibilityGroup[] = [];
  selectedVisibilityGroup: any;
  selectedVisibilityGroupsChild: any;
  assignedUserGroups: any;
  displayAddAccountsOrLeads: boolean = false;
  addAccountsOrLeadsHeader: string = '';
  layerNo: number = 1;
  allModules: any[] = [];
  selectedModule: any;
  allChannels: ChannelN[] = [];
  selectedChannel: any;
  selectAllRecords: boolean = false;
  displayModuleDataList: boolean = false;
  manualHeaderTitle: string = "Data List";
  manualViewOnly: boolean = false;
  moduleColumnSetttings: Partial<ColumnSettingsN> = {};
  selectedRecordList: any[] = [];
  selectedRecordListDetails: any[] = [];
  selectedRecordsFromChild: any[] = [];
  sourceModuleName: string = 'VISIBILITY_GROUP';
  tableSelection: any;
  displayAccountDataListForView: boolean = false;
  displayLeadDataListForView: boolean = false;
  moduleCols: any[] = [];
  totalRecords: number = 0;
  pageSize: number = 15;
  loadingTable: boolean;
  tableShowMore: number[] = [15, 30, 50, 100];
  expandedRows: any = [];

 @ViewChild('accountsTable') accountsTable: Table | undefined;
 @ViewChild('leadsTable') leadsTable: Table | undefined;
  constructor(
    public app: AppMainComponent,
    private service: ConfigurationService,
    private formBuilder: FormBuilder,
    private confirmationService: ConfirmationService,
    private appMainService: AppMainService,
    private visibilityGroupService: VisibilityGroupService,
    private messageService: MessageService,
    private sharedChannelService: SharedChannelService,
    private columnSettingsService: SharedColumnSettingsService,
    private jobTypeService: JobTypeService

  ) {
    this.prepareVisibilityAddEditForm();
  }

  ngOnInit(): void {
    this.getUserGroupList();
    this.getJobTypeList();
    this.AddModules();
    this.configMenuProfileItems = [
      {
        label: "Add Group",
        icon: 'pi pi-plus',
        command: () => {
          this.showAddRole();
        }
      },
    ];
    this.getVisibilityGroups();
  }

  AddModules(): void {
    this.allModules = [
      {
        id: AccountModuleId,
        name: "Account"
      },
      {
        id: LeadModuleId,
        name: "Lead"
      }
    ]
  }

  prepareVisibilityAddEditForm(): void {
    this.addEditVisibilityForm = this.formBuilder.group({
      name: ['', Validators.required],
      description: [''],
      isActive: ['']
    });
  }

  getVisibilityGroups(): void {
    this.appMainService.isShowSpinner('getVisibilityGroups');
    this.visibilityGroupService.getUserVisibilityGroups()
    .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe({
              next: (response) => {
                this.visibilityGroup = response;
                this.appMainService.isHideSpinner('getVisibilityGroups');
              },
              error: ((error) => {
                  this.appMainService.isHideSpinner('getVisibilityGroups');
                  this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: error?.error?.Message ? error?.error?.Message : 'Error occured, please try again later..'
                  });
              }),
              complete: (() => {
              })
        });
  }

  showAddRole(): void{
    this.addEditVisibilityHeader = 'Add Visibility Group';
    this.displayAddEditVisibilityModal = true;
  }

  editVisibilityGroup(editData) {
    this.addEditVisibilityHeader = 'Edit Visibility Group';
    this.displayAddEditVisibilityModal = true;
    this.addEditVisibilityForm = this.formBuilder.group({
      id: [editData?.id],
      name: [editData?.name, Validators.required],
      description: [editData?.description],
      isActive: [editData?.statusId == 1 ? true : editData?.statusId == 2 ? false : false]
    });
  }

  closeVisibilityAddEditModal(): void {
    this.addEditVisibilityForm.reset();
    this.displayAddEditVisibilityModal = false;
  }

  saveVisibilityGroup(): void {
    const groupData = {
      ...(this.addEditVisibilityForm.value['id'] ? {id: this.addEditVisibilityForm.value['id']} : {}),
      name: this.addEditVisibilityForm.value['name'],
      description: this.addEditVisibilityForm.value['description'],
      statusId: this.addEditVisibilityForm.value['isActive'] ? 1 : 2
    }
    if (groupData?.id){
      this.updateVisibilityGroup(groupData);
    }
    else {
      this.addVisibilityGroup(groupData);
    }

  }

  addVisibilityGroup(groupData): void {
    this.appMainService.isShowSpinner('saveVisibilityGroup');
    this.visibilityGroupService.addVisibilityGroup(groupData)
    .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe({
              next: (response) => {
                this.getVisibilityGroups();
                this.addEditVisibilityForm.reset();
                this.displayAddEditVisibilityModal = false;
                this.messageService.add({ severity: 'success', summary: 'Success', detail: `Visibility group added duccessfully...` });
                this.appMainService.isHideSpinner('saveVisibilityGroup');
              },
              error: ((error) => {
                  this.appMainService.isHideSpinner('saveVisibilityGroup');
                  this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: error?.error?.Message ? error?.error?.Message : 'Error occured, please try again later..'
                  });
              }),
              complete: (() => {
                this.appMainService.isHideSpinner('saveVisibilityGroup');
              })
        });
  }

  updateVisibilityGroup(groupData): void {
    this.appMainService.isShowSpinner('saveVisibilityGroup');
    this.visibilityGroupService.updateVisibilityGroup(groupData)
    .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe({
              next: (response) => {
                this.getVisibilityGroups();
                this.addEditVisibilityForm.reset();
                this.displayAddEditVisibilityModal = false;
                this.messageService.add({ severity: 'success', summary: 'Success', detail: `Visibility group added duccessfully...` });
                this.appMainService.isHideSpinner('saveVisibilityGroup');
              },
              error: ((error) => {
                  this.appMainService.isHideSpinner('saveVisibilityGroup');
                  this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: error?.error?.Message ? error?.error?.Message : 'Error occured, please try again later..'
                  });
              }),
              complete: (() => {
                this.appMainService.isHideSpinner('saveVisibilityGroup');
              })
        });
  }

  deleteVisibilityConfirmation(data){
    this.confirmationService.confirm({
      message: 'Do you want to delete this group?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.deleteVisibility(data);
      },
      reject: () => {
      }
    });

  }

  deleteVisibility(data): void {
    this.appMainService.isShowSpinner('deleteVisibility');
    this.visibilityGroupService.deleteVisibityGroup(data?.id)
    .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe({
              next: (response) => {
                this.getVisibilityGroups();
                this.messageService.add({ severity: 'success', summary: 'Success', detail: `Visibility group deleted duccessfully...` });
                this.appMainService.isHideSpinner('deleteVisibility');
              },
              error: ((error) => {
                  this.appMainService.isHideSpinner('deleteVisibility');
                  this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: error?.error?.Message ? error?.error?.Message : 'Error occured, please try again later..'
                  });
              }),
              complete: (() => {
              })
        });
  }

  addResource(groupData, child){
    switch (child.objectId) {
        case 1: //Lead
            this.selectedModule = this.allModules[1];
            this.getChannels(this.selectedModule);
            this.addAccountsOrLeadsHeader = 'Add Lead';
            this.selectedVisibilityGroup = groupData;
            this.selectedRecordList = [];
            this.selectAllRecords = !!child?.allSelect;
            if (child?.objectcount > 0 && !this.selectAllRecords){
                this.getAssignedModuleRecord(child?.objectId, this.selectedVisibilityGroup?.id);
            }

            this.displayAddAccountsOrLeads = true;
            break;
        case 2: //Account
            this.selectedModule = this.allModules[0];
            this.getChannels(this.selectedModule);
            this.addAccountsOrLeadsHeader = 'Add Account';
            this.selectedVisibilityGroup = groupData;

            this.selectedRecordList = [];
            this.selectAllRecords = !!child?.allSelect;
            if (child?.objectcount > 0 && !this.selectAllRecords){
              this.getAssignedModuleRecord(child?.objectId, this.selectedVisibilityGroup?.id);
            }
            this.selectAllRecords = !!child?.allSelect;
            this.displayAddAccountsOrLeads = true;
            break;

        default:
            this.addJobTypeUsers(groupData, child);
            break;
    }
  }

  changeChannel(selectedChannel): void {
    this.getColumnSetting();
    this.getAssignedModuleRecord(this.selectedModule?.id, this.selectedVisibilityGroup?.id);
  }

  addUserGroup(groupData, child){
    this.getUserGroupList();
    this.displayUserGroupTB = true;
    this.selectedVisibilityGroup = groupData;
    this.selectedVisibilityGroupsChild = child;
    if (this.selectedVisibilityGroupsChild.objectcount > 0){
      this.getAssignedUserGroup(this.selectedVisibilityGroup?.id, true);
    }
  }

  getAssignedUserGroup(visibilityGroupId, findSelectedUsers = false, fromViewSource = false) {
    this.appMainService.isShowSpinner('getAssignedUserGroup');
    this.visibilityGroupService.getAssignedUserGroup(visibilityGroupId)
    .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe({
              next: (response) => {
                this.assignedUserGroups = response;
                if (findSelectedUsers){
                  this.findSelectedUserGroups();
                }
                if (fromViewSource){
                  this.findUserGroupsForView();
                  this.displaySelectedUserGroupTB = true;
                }
                this.appMainService.isHideSpinner('getAssignedUserGroup');
                //console.log(this.assignedUserGroups);
              },
              error: ((error) => {
                  this.appMainService.isHideSpinner('getAssignedUserGroup');
                  this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: error?.error?.Message ? error?.error?.Message : 'Assigned user group not found, please try again later..'
                  });
              }),
              complete: (() => {
              })
        });
  }

  addJobTypeUsers(groupData, child){
    this.displaySelectedJobTypeUsersTB = true;
    this.addJobTypeUserEnable = true;
    this.selectedVisibilityGroup = groupData;
    this.selectedVisibilityGroupsChild = child;
    this.getAssignedJobTypeUsers(this.selectedVisibilityGroup?.id);
  }

  showJobTypeDialog(jobType: any){
    this.appMainService.isShowSpinner('getAssociatedUsers');
    this.jobTypeService.getAssociatedUsers(jobType.id)
    .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe({
            next: (response) => {
            this.allJobTypeUsers = response;
            this.selectedJobType = ParseHelper.DeepCopy(jobType);
            this.findSelectedJobTypeUsers();
            this.displaySelectJobTypeUsersTB = true;
            this.appMainService.isHideSpinner('getAssociatedUsers');
            //console.log(this.assignedUserGroups);
            },
            error: ((error) => {
                this.appMainService.isHideSpinner('getAssociatedUsers');
                this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: error?.error?.Message ? error?.error?.Message : 'Assigned user job type not found, please try again later..'
                });
            }),
            complete: (() => {
            })
    });
  }

  findSelectedJobTypeUsers(){
    this.selectedJobTypeUsers = this.selectedJobType.addedUsers?.length>0 ? ParseHelper.DeepCopy(this.selectedJobType.addedUsers) : [];
    this.includeAllUsersToggle();
  }

  getAssignedJobTypeUsers(visibilityGroupId, fromViewSource = false) {
    this.appMainService.isShowSpinner('getAssignedJobTypeUsers');
    this.visibilityGroupService.getAssignedJobTypeUsers(visibilityGroupId)
    .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe({
              next: (response) => {
                this.assignedJobTypeUsers = response;
                this.findSelectedJobTypeusers();
                if(fromViewSource) this.displaySelectedJobTypeUsersTB = true;
                this.appMainService.isHideSpinner('getAssignedJobTypeUsers');
                //console.log(this.assignedUserGroups);
              },
              error: ((error) => {
                  this.appMainService.isHideSpinner('getAssignedJobTypeUsers');
                  this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: error?.error?.Message ? error?.error?.Message : 'Assigned user job type not found, please try again later..'
                  });
              }),
              complete: (() => {
              })
        });
  }

  findSelectedJobTypeusers(){
    this.jobTypeListByVisibility = ParseHelper.DeepCopy(this.jobTypeList);
    this.jobTypeListByVisibility.map(jobType=>{
        jobType.addedUsers = this.assignedJobTypeUsers.filter(type=> type.jobTypeId==jobType.id);
    })
  }

  includeAllUsersToggle(update: boolean = false){
    if(update)
    this.selectedJobTypeUsers = (this.allJobTypeUsers?.length==this.selectedJobTypeUsers?.length) ? [] : this.allJobTypeUsers;

    setTimeout(()=>{
        this.selectedJobTypeUsersToggle = !!(this.allJobTypeUsers?.length==this.selectedJobTypeUsers?.length);
    })
  }

  includeUsers(){
    const selectedJobType = this.jobTypeListByVisibility.find(j=> j.id===this.selectedJobType.id);
    selectedJobType.addedUsers = ParseHelper.DeepCopy(this.selectedJobTypeUsers);
    this.displaySelectJobTypeUsersTB = false;
  }

  onUserSelect(){
    this.includeAllUsersToggle();
  }

  onUserUnselect(){
    this.includeAllUsersToggle();
  }

 saveJobTypeUser(){
    const userIds = [];
    this.jobTypeListByVisibility.map(jobDetails=>{
        jobDetails?.addedUsers?.map(user=>{
            userIds.push(user.userId)
        })
    })

    const userGroupData : UserGroupsAdd = {
      visibilityGroupID: this.selectedVisibilityGroup?.id,
      userGroupID: userIds,
      statusId: this.selectedVisibilityGroup.statusId
    }

    this.appMainService.isShowSpinner('saveUserGroup');
    this.visibilityGroupService.addUserGroup(userGroupData)
    .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe({
              next: (response) => {
                this.getVisibilityGroups();
                this.displaySelectedJobTypeUsersTB = false;
                this.messageService.add({ severity: 'success', summary: 'Success', detail: `Job Type Users added duccessfully...` });
                this.appMainService.isHideSpinner('saveUserGroup');
              },
              error: ((error) => {
                  this.appMainService.isHideSpinner('saveUserGroup');
                  this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: error?.error?.Message ? error?.error?.Message : 'Error occured, please try again later..'
                  });
              }),
              complete: (() => {
              })
        });

    this.displayUserGroupTB = false;
  }


  getAssignedModuleRecord(moduleId, visibilityGroupId): void {
      this.appMainService.isShowSpinner('getAssignedModuleRecord');
      this.visibilityGroupService.getAssignedModuleRecordMinified(moduleId, visibilityGroupId)
      .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe({
              next: (response) => {
                this.selectedRecordList = response || [];
                this.appMainService.isHideSpinner('getAssignedModuleRecord');
              },
              error: ((error) => {
                  this.appMainService.isHideSpinner('getAssignedModuleRecord');
                  this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: error?.error?.Message ? error?.error?.Message : 'Assigned user group not found, please try again later..'
                  });
              }),
              complete: (() => {
              })
        });
  }


  getExpandedRows(list, main?): void {
    list.forEach(element => {
        element.viewDetails = main == 'main' ? true : false;
        if (element.hasChildAccounts) {
            this.expandedRows[element.id] = false;
        }
    });
  }

  onExpandRow(parentId, parent, expanded){

  }

  findSelectedUserGroups(): void {
    this.selectedUserGroups = [];
    this.selectedUserGroups = this.assignedUserGroups.map((item) => {
      const matchObj = this.allUserGroup.find(obj => obj?.id === item?.groupId);
      return {
        id: item?.groupId
      }
    })
  }

  viewResource(groupData, child){

    switch (child.objectId) {
        case 1: //Lead
            this.selectedModule = this.allModules[1];
            this.selectedVisibilityGroup = groupData;
            this.getChannels(this.selectedModule, true, child.objectId, groupData.id);
            this.tableSelection = child;
            break;
        case 2:
            this.selectedModule = this.allModules[0];
            this.getChannels(this.selectedModule, true, child.objectId, groupData.id);
            this.tableSelection = child;
            this.selectedVisibilityGroup = groupData;
            break;

        default:
            this.selectedVisibilityGroup = groupData;
            this.selectedVisibilityGroupsChild = child;
            this.addJobTypeUserEnable = false;
            this.getAssignedJobTypeUsers(groupData.id, true);
            break;
    }
  }

  findUserGroupsForView(): void {
    this.allUserGroupForView = this.assignedUserGroups?.map((item) => {
      const matchObj = this.allUserGroup?.find(obj => obj?.id === item?.groupId);
      return {
        id: item?.groupId,
        group: matchObj?.group,
        ownerList: matchObj?.ownerList,
        statusId: matchObj?.statusId
      }
    });
   //console.log(this.allUserGroupForView);
  }

  showEditUserGroupFromView(){
    this.displaySelectedUserGroupTB = false;
    this.addUserGroup(this.selectedVisibilityGroup, this.selectedVisibilityGroupsChild);
  }

  saveUserGroup(){
    const userGroupIds = this.selectedUserGroups.map(obj => obj.id);

    const userGroupData : UserGroupsAdd = {
      visibilityGroupID: this.selectedVisibilityGroup?.id,
      userGroupID: userGroupIds,
      statusId: this.selectedVisibilityGroup.statusId
    }

    this.appMainService.isShowSpinner('saveUserGroup');
    this.visibilityGroupService.addUserGroup(userGroupData)
    .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe({
              next: (response) => {
                this.getVisibilityGroups();
                this.displayUserGroupTB = false;
                this.messageService.add({ severity: 'success', summary: 'Success', detail: `User group added duccessfully...` });
                this.appMainService.isHideSpinner('saveUserGroup');
              },
              error: ((error) => {
                  this.appMainService.isHideSpinner('saveUserGroup');
                  this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: error?.error?.Message ? error?.error?.Message : 'Error occured, please try again later..'
                  });
              }),
              complete: (() => {
              })
        });

    this.displayUserGroupTB = false;
  }

  getUserGroupList() {
    this.service.getOrgUserGroups(this.app.user.organizationId)
      .pipe(
        map(res => {
          return res.map(group => {
            let groupOwnersList: any[]=[];
            group.groupOwners.map(groupOwner => {
              groupOwnersList.push(groupOwner.name);
            })
            group.ownerList = groupOwnersList.join(', ');
            if (group.parentGroup) {
              delete group.parentGroup
            }
            return group;
          })
        })
      ).subscribe(resp => {
        this.loading = false;
        this.allUserGroup = [...resp];
        this.allUserGroup.sort(function (a, b) {
          var nameA = a.group.name.toLowerCase(), nameB = b.group.name.toLowerCase()
          if (nameA < nameB) //sort string ascending
            return -1
          if (nameA > nameB)
            return 1
          return 0 //default return value (no sorting)
        })
      });
  }

  getJobTypeList(){
    this.jobTypeService.getJobTypes().pipe(takeUntil(this.ngUnsubscribe)).subscribe({
        next: (response)=>{
            this.jobTypeList = response||[];
        },
        error: (error)=>{

        }
    })
  }

  getChannels(selectedModule, fromViewResouce = false, moduleIdForViewResouce?, visibilityGroupIdForViewResource?): void {
        this.appMainService.isShowSpinner('getChannel');
        this.sharedChannelService.getChannels(selectedModule?.id)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
                {
                    next: (response) => {
                        this.allChannels = response || [];
                        this.selectedChannel = response.find(x => x?.isDefault == true);
                        this.appMainService.isHideSpinner('getChannel');
                        this.getColumnSetting(fromViewResouce, moduleIdForViewResouce, visibilityGroupIdForViewResource);
                    },
                    error: (error) => {
                        this.appMainService.isHideSpinner('getChannel');
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Error',
                            detail: error?.error?.message ? error?.error?.message : 'Channels are not loaded, please try again...'
                        });

                    },
                    complete: () => {
                        //this.getChannelStage(this.selectedChannelN?.id);
                    },
                });
  }

  getDataLists(){
    this.displayAddAccountsOrLeads = false;
    this.manualHeaderTitle = "Data Lists";
    this.manualViewOnly = false;
    this.displayModuleDataList = true;
  }

  getColumnSetting(fromViewResouce = false, moduleIdForViewResouce?, visibilityGroupIdForViewResource?){
    this.moduleColumnSetttings.listViewSections = [];
    this.appMainService.isShowSpinner("getColumnSetting");
    this.columnSettingsService
        .getColumnSettings(this.selectedModule?.id, this.selectedChannel?.id)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe({
            next: (response) => {
                this.moduleColumnSetttings = response;
                if (fromViewResouce && !this.tableSelection?.allSelect){
                  this.getAssignedModuleRecordDetails(fromViewResouce, moduleIdForViewResouce, visibilityGroupIdForViewResource);
                } else if(fromViewResouce && this.tableSelection?.allSelect){
                    this.manualHeaderTitle = `All ${this.selectedModule.name} Lists`;
                    this.manualViewOnly = true;
                    this.displayModuleDataList = true;
                }
                this.appMainService.isHideSpinner("getColumnSetting");
            },
            error: (error) => {
                this.appMainService.isHideSpinner("getColumnSetting");
                this.messageService.add({
                    severity: "error",
                    summary: "Error",
                    detail: error?.error?.message
                        ? error?.error?.message
                        : "Column settings are not loaded, please try again...",
                });
            },
            complete: () => {},
        });
  }


  getAssignedModuleRecordDetails(fromViewResouce, moduleId, visibilityGroupId): void {
    this.moduleCols = this.selectedRecordListDetails = [];
    const listCols = this.moduleColumnSetttings?.listViewSections?.length ? getSectionWiseFlatCols(this.moduleColumnSetttings?.listViewSections) : [];
    this.moduleCols = listCols;
    this.getExpandedRows(this.moduleCols, 'main');
    const selectableColumns: any[] = [];

      if (listCols.length > 0) {
          listCols.forEach((obj) => {
              if (obj.enabled) {
                  selectableColumns.push(
                      {
                          columnName: obj.columnName,
                          isCustom: obj.isCustom
                      }
                  )
              }
          });
      }

      const requestModel = {
        selectableColumns: selectableColumns,
        pageSize: 0,
        pageNumber: 0
      }

      this.appMainService.isShowSpinner('getAssignedModuleRecord');
      this.visibilityGroupService.getAssignedModuleRecord(moduleId, visibilityGroupId, requestModel)
      .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe({
              next: (response) => {
                this.selectedRecordListDetails = response?.list || [];
                this.totalRecords = response?.totalNumberOfRows;
                this.loadingTable = false;
                if (fromViewResouce && moduleId == LeadModuleId){
                  this.displayLeadDataListForView = true;
                }
                if (fromViewResouce && moduleId == AccountModuleId){
                  this.displayAccountDataListForView = true;
                }
                this.appMainService.isHideSpinner('getAssignedModuleRecord');
              },
              error: ((error) => {
                  this.appMainService.isHideSpinner('getAssignedModuleRecord');
                  this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: error?.error?.Message ? error?.error?.Message : 'Assigned user group not found, please try again later..'
                  });
              }),
              complete: (() => {
              })
        });
  }

  saveAssignData($event, allSelect: boolean = false){

    let selectedRecordsIds: number[] = [];

    if(allSelect){
        selectedRecordsIds = [0,1,2];
    }else{
        this.selectedRecordsFromChild = JSON.parse(JSON.stringify($event.selectedReccords));
        selectedRecordsIds = this.selectedRecordsFromChild.map(obj => obj.id);
    }

    // const previousRecordsIds = this.selectedRecordList.map(obj => obj.id);
    // const finalRecordsIds = [...new Set([...previousRecordsIds, ...selectedRecordsIds])];

    const userGroupData : AddModuleRecord = {
      visibilityGroupID: this.selectedVisibilityGroup?.id,
      idList: selectedRecordsIds,
      moduleTypeId: this.selectedModule?.id
    }

    this.appMainService.isShowSpinner('saveUserGroup');
    this.visibilityGroupService.addModuleRecord(userGroupData)
    .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe({
              next: (response) => {
                this.getVisibilityGroups();
                this.displayAddAccountsOrLeads = false;
                this.displayModuleDataList = false;
                this.selectedRecordList = [];
                this.messageService.add({ severity: 'success', summary: 'Success', detail: `Data added duccessfully...` });
                this.appMainService.isHideSpinner('saveUserGroup');
              },
              error: ((error) => {
                  this.appMainService.isHideSpinner('saveUserGroup');
                  this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: error?.error?.Message ? error?.error?.Message : 'Error occured, please try again later..'
                  });
              }),
              complete: (() => {
              })
    });
  }

  cancelClickedModuleDataList(){
    this.displayModuleDataList = false;
    this.displayAddAccountsOrLeads = false;
  }

  closeAddAccountOrLeadModal(){
    this.selectedModule = null;
    this.selectedChannel = null;
    this.displayAddAccountsOrLeads = false;
  }

  closeAccountDataListForView(){
    this.displayAccountDataListForView = false;
    this.moduleCols = [];
    this.selectedRecordListDetails = [];
    this.accountsTable?.reset();
    this.moduleColumnSetttings.listViewSections = [];
  }

  closeLeadDataListForView(){
    this.displayLeadDataListForView = false;
    this.moduleCols = [];
    this.selectedRecordListDetails = [];
    this.leadsTable?.reset();
    this.moduleColumnSetttings.listViewSections = [];
  }

  backToModuleClicked(){
    this.displayModuleDataList = false;
    this.displayAddAccountsOrLeads = true;
  }

  get name() { return this.addEditVisibilityForm.get('name'); }

  onDeleteSelectedList(rowData, selectedRecordListDetails) {
    this.confirmationService.confirm({
      message: 'Do you want to delete?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        const selectedRecordListIds = selectedRecordListDetails.map(record => record?.id);
        const filteredIds = selectedRecordListIds.filter(id => id !== rowData?.id);
        const userGroupData: AddModuleRecord = {
          visibilityGroupID: this.selectedVisibilityGroup?.id,
          idList: filteredIds,
          moduleTypeId: this.selectedModule?.id
        };
  
        this.appMainService.isShowSpinner('saveUserGroup');
        this.visibilityGroupService.addModuleRecord(userGroupData)
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe({
            next: (response) => {
              this.getVisibilityGroups();
              this.getAssignedModuleRecordDetails(true, this.selectedModule?.id, this.selectedVisibilityGroup?.id,);
              this.messageService.add({ severity: 'success', summary: 'Success', detail: `Deleted successfully...` });
              this.appMainService.isHideSpinner('saveUserGroup');
            },
            error: () => {
              this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error occurred while deleting data...' });
            }
          });
      },
      reject: () => {
        // Code for reject
      }
    });
  }
  
  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

}
